import React, { useState } from 'react';
import DocumentUploadModal from '../admin/DocumentUploadModal';
import apiService from '../../services/api';

const TaskCard = ({ task, onEdit, onDelete, onAssign, onStatusChange, onRefresh, onShowTimeline }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showTemperatureModal, setShowTemperatureModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [assigneeEmail, setAssigneeEmail] = useState('');
  const [newStatus, setNewStatus] = useState('');
  const [newTemperature, setNewTemperature] = useState('');
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadFiles, setUploadFiles] = useState([]);


  const handleEdit = (task) => {
    setEditData({
      name: task.task_details?.name || task.name || '',
      description: task.task_details?.description || '',
      due_date: task.due_date ? task.due_date.split('T')[0] : '',
      temperature: task.temperature || 'warm'
    });
    setShowEditModal(true);
  };

  const handleAssign = (task) => {
    setAssigneeEmail(task.assignee_email || '');
    setShowAssignModal(true);
  };

  const handleStatusChange = (task) => {
    setNewStatus(task.status || 'pending');
    setShowStatusModal(true);
  };

  const handleTemperatureChange = (task) => {
    setNewTemperature(task.temperature || 'warm');
    setShowTemperatureModal(true);
  };

  const submitEdit = async () => {
    try {
      await apiService.put(`/tasks/${task.id}`, editData);
      setShowEditModal(false);
      onRefresh?.();
    } catch (error) {
      console.error('Edit failed:', error);
    }
  };

  const submitAssign = async () => {
    try {
      await apiService.put(`/tasks/${task.id}/assign`, { assignee_email: assigneeEmail });
      setShowAssignModal(false);
      onRefresh?.();
    } catch (error) {
      console.error('Assign failed:', error);
    }
  };

  const submitStatusChange = async () => {
    try {
      const data = await apiService.put(`/tasks/${task.id}/status`, { status: newStatus });
      setShowStatusModal(false);

      // Show document upload modal if status is registered
      if (newStatus === 'registered') {
        setShowDocumentModal(true);
      } else {
        onRefresh?.();
      }
    } catch (error) {
      console.error('Status change failed:', error);
    }
  };

  const submitTemperatureChange = async () => {
    try {
      await apiService.put(`/tasks/${task.id}/temperature`, { temperature: newTemperature });
      setShowTemperatureModal(false);
      onRefresh?.();
    } catch (error) {
      console.error('Temperature change failed:', error);
    }
  };



  const getStatusColor = (status) => {
    switch (status) {
      case 'registered': return '#4caf50';
      case 'pending_verification': return '#ff9800';
      case 'verified': return '#4caf50';
      case 'rejected': return '#f44336';
      case 'sent_to_accounts': return '#2196f3';
      case 'in_progress': return '#2196f3';
      case 'pending': return '#ff9800';
      case 'overdue': return '#f44336';
      default: return '#9e9e9e';
    }
  };

  const getTemperatureColor = (temperature) => {
    switch (temperature) {
      case 'hot': return '#f44336';
      case 'warm': return '#ff9800';
      case 'cold': return '#2196f3';
      default: return '#9e9e9e';
    }
  };

  const getTemperatureIcon = (temperature) => {
    switch (temperature) {
      case 'hot': return '🔥';
      case 'warm': return '🌡️';
      case 'cold': return '❄️';
      default: return '🌡️';
    }
  };

  const getProgressValue = (status) => {
    switch (status) {
      case 'registered': return 100;
      case 'in_progress': return 60;
      case 'pending': return 20;
      case 'overdue': return 10;
      default: return 0;
    }
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '16px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)',
      border: '1px solid rgba(226, 232, 240, 0.8)',
      position: 'relative',
      transition: 'all 0.3s ease',
      cursor: 'pointer'
    }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.12), 0 4px 8px rgba(0,0,0,0.06)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)';
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
        <div style={{ flex: 1 }}>
          <h3 style={{
            margin: '0 0 8px 0',
            fontSize: '18px',
            fontWeight: '700',
            color: '#1a202c',
            lineHeight: '1.3'
          }}>
            📋 {task.task_details?.name || task.task_details?.Name || task.name || 'Untitled Task'}
          </h3>
          <div style={{
            fontSize: '13px',
            color: '#718096',
            fontWeight: '500'
          }}>
            ID: #{task.id || 'N/A'}
          </div>
        </div>
        <button
          onClick={() => setShowMenu(!showMenu)}
          style={{
            background: 'rgba(102, 126, 234, 0.1)',
            border: '1px solid rgba(102, 126, 234, 0.2)',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '8px',
            fontSize: '16px',
            color: '#667eea',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#667eea';
            e.target.style.color = 'white';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(102, 126, 234, 0.1)';
            e.target.style.color = '#667eea';
          }}
        >
          ⋮
        </button>
      </div>

      <div style={{
        margin: '0 0 16px 0',
        padding: '16px',
        background: 'rgba(248, 250, 252, 0.8)',
        borderRadius: '8px',
        border: '1px solid rgba(226, 232, 240, 0.6)'
      }}>
        {Object.entries(task.task_details || {}).filter(([key]) =>
          !['task_board_type', 'Task_Board_Type', 'Task Board Type', 'allocation_board'].includes(key)
        ).map(([key, value]) => (
          <div key={key} style={{
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <span style={{
              fontSize: '13px',
              fontWeight: '600',
              color: '#4a5568',
              minWidth: '100px',
              textTransform: 'capitalize'
            }}>
              {key.replace(/_/g, ' ')}:
            </span>
            <span style={{
              fontSize: '14px',
              color: '#2d3748',
              fontWeight: '500',
              flex: 1
            }}>
              {value}
            </span>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
        <span style={{
          background: `linear-gradient(135deg, ${getStatusColor(task.status || 'pending')}, ${getStatusColor(task.status || 'pending')}dd)`,
          color: 'white',
          padding: '8px 16px',
          borderRadius: '20px',
          fontSize: '13px',
          fontWeight: '600',
          boxShadow: `0 2px 8px ${getStatusColor(task.status || 'pending')}40`,
          textTransform: 'capitalize',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}>
          📊 {(task.status || 'pending').replace('_', ' ')}
        </span>
        <span style={{
          background: `linear-gradient(135deg, ${getTemperatureColor(task.temperature || 'warm')}, ${getTemperatureColor(task.temperature || 'warm')}dd)`,
          color: 'white',
          padding: '8px 16px',
          borderRadius: '20px',
          fontSize: '13px',
          fontWeight: '600',
          boxShadow: `0 2px 8px ${getTemperatureColor(task.temperature || 'warm')}40`,
          textTransform: 'capitalize',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}>
          {getTemperatureIcon(task.temperature || 'warm')}
          {task.temperature || 'warm'}
        </span>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '8px'
        }}>
          <span style={{ fontSize: '13px', color: '#4a5568', fontWeight: '600' }}>
            📈 Progress
          </span>
          <span style={{
            fontSize: '12px',
            color: '#667eea',
            fontWeight: '700',
            background: 'rgba(102, 126, 234, 0.1)',
            padding: '2px 8px',
            borderRadius: '12px'
          }}>
            {getProgressValue(task.status)}%
          </span>
        </div>
        <div style={{
          background: 'rgba(226, 232, 240, 0.8)',
          height: '8px',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            background: `linear-gradient(90deg, ${getStatusColor(task.status)}, ${getStatusColor(task.status)}cc)`,
            height: '100%',
            width: `${getProgressValue(task.status)}%`,
            transition: 'width 0.5s ease',
            borderRadius: '12px',
            boxShadow: `0 1px 3px ${getStatusColor(task.status)}60`
          }} />
        </div>
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 16px',
        background: 'rgba(102, 126, 234, 0.05)',
        borderRadius: '10px',
        border: '1px solid rgba(102, 126, 234, 0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: task.assignee_email || task.assignedTo
              ? 'linear-gradient(135deg, #667eea, #764ba2)'
              : 'linear-gradient(135deg, #e2e8f0, #cbd5e0)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '16px',
            fontWeight: '700',
            boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)'
          }}>
            {task.assignee_email || task.assignedTo
              ? (task.assignee_email || task.assignedTo?.name || 'U').charAt(0).toUpperCase()
              : '?'
            }
          </div>
          <div>
            <div style={{
              fontSize: '14px',
              fontWeight: '600',
              color: '#2d3748',
              marginBottom: '2px'
            }}>
              {task.assignee_email || task.assignedTo?.name || 'Unassigned'}
            </div>
            <div style={{
              fontSize: '12px',
              color: '#718096',
              fontWeight: '500'
            }}>
              {task.assignee_email ? 'Assigned' : 'Awaiting Assignment'}
            </div>
          </div>
        </div>
        <div style={{
          padding: '6px 12px',
          background: task.assignee_email || task.assignedTo
            ? 'rgba(72, 187, 120, 0.1)'
            : 'rgba(237, 137, 54, 0.1)',
          color: task.assignee_email || task.assignedTo
            ? '#38a169'
            : '#dd6b20',
          borderRadius: '16px',
          fontSize: '12px',
          fontWeight: '600',
          border: `1px solid ${task.assignee_email || task.assignedTo
            ? 'rgba(72, 187, 120, 0.2)'
            : 'rgba(237, 137, 54, 0.2)'}`
        }}>
          {task.assignee_email || task.assignedTo ? '✓ Assigned' : '⚠ Pending'}
        </div>
      </div>

      {showMenu && (
        <>
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 9,
              background: 'transparent'
            }}
            onClick={() => setShowMenu(false)}
          />
          <div style={{
            position: 'absolute',
            top: '40px',
            right: '16px',
            background: 'white',
            border: '1px solid #ddd',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            zIndex: 10,
            minWidth: '160px',
            overflow: 'hidden',
            animation: 'fadeIn 0.15s ease-out'
          }}>
            <style>
              {`
                @keyframes fadeIn {
                  from { opacity: 0; transform: translateY(-8px); }
                  to { opacity: 1; transform: translateY(0); }
                }
              `}
            </style>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(task);
                setShowMenu(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: '100%',
                padding: '14px 16px',
                border: 'none',
                background: 'white',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#333',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
                e.target.style.transform = 'translateX(2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <span style={{ fontSize: '16px' }}>✏️</span>
              Edit Task
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleAssign(task);
                setShowMenu(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: '100%',
                padding: '14px 16px',
                border: 'none',
                background: 'white',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#333',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
                e.target.style.transform = 'translateX(2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <span style={{ fontSize: '16px' }}>👤</span>
              Assign Task
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleStatusChange(task);
                setShowMenu(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: '100%',
                padding: '14px 16px',
                border: 'none',
                background: 'white',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#333',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
                e.target.style.transform = 'translateX(2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <span style={{ fontSize: '16px' }}>🔄</span>
              Change Status
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleTemperatureChange(task);
                setShowMenu(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: '100%',
                padding: '14px 16px',
                border: 'none',
                background: 'white',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#333',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
                e.target.style.transform = 'translateX(2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <span style={{ fontSize: '16px' }}>🌡️</span>
              Change Temperature
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                if (onShowTimeline) {
                  onShowTimeline(task);
                }
                setShowMenu(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: '100%',
                padding: '14px 16px',
                border: 'none',
                background: 'white',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#333',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
                e.target.style.transform = 'translateX(2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <span style={{ fontSize: '16px' }}>📋</span>
              View Timeline
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowUploadModal(true);
                setShowMenu(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: '100%',
                padding: '14px 16px',
                border: 'none',
                background: 'white',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#333',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f8f9fa';
                e.target.style.transform = 'translateX(2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <span style={{ fontSize: '16px' }}>📎</span>
              Upload Document
            </button>
            <div style={{ height: '1px', background: '#e9ecef', margin: '8px 0' }} />
            <button
              onClick={(e) => {
                e.stopPropagation();
                console.log('Delete clicked', { onDelete: !!onDelete, taskId: task.id });
                if (onDelete) {
                  onDelete(task.id);
                } else {
                  console.warn('onDelete function not provided');
                }
                setShowMenu(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: '100%',
                padding: '14px 16px',
                border: 'none',
                background: 'white',
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#dc3545',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#fff5f5';
                e.target.style.transform = 'translateX(2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.transform = 'translateX(0)';
              }}
            >
              <span style={{ fontSize: '16px' }}>🗑️</span>
              Delete Task
            </button>
          </div>
        </>
      )}

      {/* Edit Modal */}
      {showEditModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', padding: '24px', borderRadius: '12px', width: '400px', maxWidth: '90vw' }}>
            <h3 style={{ margin: '0 0 16px 0' }}>Edit Task</h3>
            <input placeholder="Task Name" value={editData.name} onChange={(e) => setEditData({ ...editData, name: e.target.value })} style={{ width: '100%', padding: '8px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '4px' }} />
            <textarea placeholder="Description" value={editData.description} onChange={(e) => setEditData({ ...editData, description: e.target.value })} style={{ width: '100%', padding: '8px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '4px', minHeight: '80px' }} />

            <select value={editData.temperature} onChange={(e) => setEditData({ ...editData, temperature: e.target.value })} style={{ width: '100%', padding: '8px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '4px' }}>
              <option value="cold">❄️ Cold</option>
              <option value="warm">🌡️ Warm</option>
              <option value="hot">🔥 Hot</option>
            </select>
            <input type="date" value={editData.due_date} onChange={(e) => setEditData({ ...editData, due_date: e.target.value })} style={{ width: '100%', padding: '8px', marginBottom: '16px', border: '1px solid #ddd', borderRadius: '4px' }} />
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowEditModal(false)} style={{ padding: '8px 16px', border: '1px solid #ddd', background: 'white', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
              <button onClick={submitEdit} style={{ padding: '8px 16px', border: 'none', background: '#2196f3', color: 'white', borderRadius: '4px', cursor: 'pointer' }}>Save</button>
            </div>
          </div>
        </div>
      )}

      {/* Assign Modal */}
      {showAssignModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', padding: '24px', borderRadius: '12px', width: '400px', maxWidth: '90vw' }}>
            <h3 style={{ margin: '0 0 16px 0' }}>Reassign Task</h3>
            <input placeholder="Academic Counsellor Email" value={assigneeEmail} onChange={(e) => setAssigneeEmail(e.target.value)} style={{ width: '100%', padding: '8px', marginBottom: '16px', border: '1px solid #ddd', borderRadius: '4px' }} />
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowAssignModal(false)} style={{ padding: '8px 16px', border: '1px solid #ddd', background: 'white', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
              <button onClick={submitAssign} style={{ padding: '8px 16px', border: 'none', background: '#2196f3', color: 'white', borderRadius: '4px', cursor: 'pointer' }}>Assign</button>
            </div>
          </div>
        </div>
      )}

      {/* Status Modal */}
      {showStatusModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', padding: '24px', borderRadius: '12px', width: '400px', maxWidth: '90vw' }}>
            <h3 style={{ margin: '0 0 16px 0' }}>Change Status</h3>
            <select value={newStatus} onChange={(e) => setNewStatus(e.target.value)} style={{ width: '100%', padding: '8px', marginBottom: '16px', border: '1px solid #ddd', borderRadius: '4px' }}>
              <option value="pending">Pending</option>
              <option value="in_progress">In Progress</option>
              <option value="registered">Registered</option>
              <option value="pending_verification">Pending Verification</option>
              <option value="verified">Verified</option>
              <option value="rejected">Rejected</option>
              <option value="sent_to_accounts">Sent to Accounts</option>
              <option value="overdue">Overdue</option>
            </select>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowStatusModal(false)} style={{ padding: '8px 16px', border: '1px solid #ddd', background: 'white', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
              <button onClick={submitStatusChange} style={{ padding: '8px 16px', border: 'none', background: '#2196f3', color: 'white', borderRadius: '4px', cursor: 'pointer' }}>Update</button>
            </div>
          </div>
        </div>
      )}

      {/* Temperature Modal */}
      {showTemperatureModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', padding: '24px', borderRadius: '12px', width: '400px', maxWidth: '90vw' }}>
            <h3 style={{ margin: '0 0 16px 0' }}>Change Temperature</h3>
            <select value={newTemperature} onChange={(e) => setNewTemperature(e.target.value)} style={{ width: '100%', padding: '8px', marginBottom: '16px', border: '1px solid #ddd', borderRadius: '4px' }}>
              <option value="cold">❄️ Cold</option>
              <option value="warm">🌡️ Warm</option>
              <option value="hot">🔥 Hot</option>
            </select>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowTemperatureModal(false)} style={{ padding: '8px 16px', border: '1px solid #ddd', background: 'white', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
              <button onClick={submitTemperatureChange} style={{ padding: '8px 16px', border: 'none', background: '#2196f3', color: 'white', borderRadius: '4px', cursor: 'pointer' }}>Update</button>
            </div>
          </div>
        </div>
      )}

      {/* Upload Modal */}
      {showUploadModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', padding: '24px', borderRadius: '12px', width: '400px', maxWidth: '90vw' }}>
            <h3 style={{ margin: '0 0 16px 0' }}>Upload Documents</h3>
            <input type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" onChange={(e) => setUploadFiles(Array.from(e.target.files))} style={{ width: '100%', padding: '8px', marginBottom: '16px', border: '1px solid #ddd', borderRadius: '4px' }} />
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowUploadModal(false)} style={{ padding: '8px 16px', border: '1px solid #ddd', background: 'white', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
              <button onClick={() => { setShowUploadModal(false); onRefresh?.(); }} style={{ padding: '8px 16px', border: 'none', background: '#2196f3', color: 'white', borderRadius: '4px', cursor: 'pointer' }}>Upload</button>
            </div>
          </div>
        </div>
      )}

      {/* Document Upload Modal */}
      <DocumentUploadModal
        show={showDocumentModal}
        onHide={() => setShowDocumentModal(false)}
        entityType="task"
        entityId={task.id}
        required={false}
        onSuccess={() => {
          setShowDocumentModal(false);
          onRefresh?.();
        }}
      />




    </div>
  );
};

export default TaskCard;